/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-26T11:31:09.435
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportRentContractRequestCheckoutLease,
	listReportRentContractRequestCheckoutLeaseInit,
	listReportRentContractRequestCheckoutLeaseByAuthorizations,
	deleteReportRentContractRequestCheckoutLease
	
} from '@api/report/ReportRentContractRequestCheckoutLease';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportRentContractRequestCheckoutLease({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractRequestCheckoutLease(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentContractRequestCheckoutLeaseByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractRequestCheckoutLeaseByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentContractRequestCheckoutLeaseInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractRequestCheckoutLeaseInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportRentContractRequestCheckoutLease({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportRentContractRequestCheckoutLease({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
